// src/components/auth/ProtectedRoute.jsx
import { useOktaAuth } from '@okta/okta-react';
import { useEffect } from 'react';

export const ProtectedRoute = ({ children }) => {
  const { authState, oktaAuth } = useOktaAuth();

  useEffect(() => {
    if (authState && !authState.isAuthenticated) {
      oktaAuth.signInWithRedirect();
    }
  }, [authState, oktaAuth]);

  // Show loading state while checking authentication
  if (!authState) {
    return <div>Loading...</div>;
  }

  if (!authState.isAuthenticated) {
    return null;
  }

  return children;
};
